import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-live-auctions',
  templateUrl: './breadcrumb-live-auctions.component.html',
  styleUrls: ['./breadcrumb-live-auctions.component.scss']
})
export class BreadcrumbLiveAuctionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
